import { useEffect, useState } from 'react';
import { useApp } from '../context/AppContext';
import { examinerRequest, examinerScope } from './examinerApi';

export const EXAMINER_AVAILABILITY_CHANGED = 'examiner-availability-changed';

export default function useExaminerVisibility() {
  const { currentUser, currentOrg, logout } = useApp();
  const admin = ['admin', 'superuser'].includes(currentUser?.user?.orgRole);
  const organizationAllowsExaminer = !!currentUser?.sessionId
    && String(currentOrg?.id) === String(currentUser?.user?.orgId)
    && currentOrg?.aiDpeEnabled === true;
  const scope = `${examinerScope(currentUser)}:${currentOrg?.id}`;
  const [availability, setAvailability] = useState(null);
  useEffect(() => {
    if (!organizationAllowsExaminer || admin || !currentUser?.sessionId) return undefined;
    let controller;
    let active = true;
    const refresh = async () => {
      controller?.abort();
      controller = new AbortController();
      const signal = controller.signal;
      try {
        const config = await examinerRequest(currentUser.sessionId, '/config', { signal });
        if (typeof config.organizationEnabled !== 'boolean') throw new Error('Invalid examiner organization availability response.');
        if (active && !signal.aborted) setAvailability({ scope, enabled: config.organizationEnabled });
      } catch (error) {
        if (!active || signal.aborted) return;
        setAvailability({ scope, enabled: false });
        console.error('Unable to load organization feature availability:', error);
        if (error.status === 401) logout?.();
      }
    };
    refresh();
    window.addEventListener('focus', refresh);
    window.addEventListener(EXAMINER_AVAILABILITY_CHANGED, refresh);
    return () => {
      active = false;
      controller?.abort();
      window.removeEventListener('focus', refresh);
      window.removeEventListener(EXAMINER_AVAILABILITY_CHANGED, refresh);
    };
  }, [organizationAllowsExaminer, admin, currentUser?.sessionId, scope, logout]);
  return organizationAllowsExaminer && (admin || (availability?.scope === scope && availability.enabled === true));
}
